import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import swal from 'sweetalert2';   

@Component({
  selector: 'app-probatorio',
  templateUrl: './probatorio.component.html',
  styleUrls: ['./probatorio.component.scss']
})
export class ProbatorioComponent implements OnInit {

  loading: boolean = false;
  bregistro = false;
  usu;
  lst;
  org_;
  itm = {
    id:0,
    clave:"",
    nombre:"",    
  }

  constructor(
    public authService: AuthService,
    public router: Router,    
  ) {     
  }

  ngOnInit(): void {
    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){
      this.ls_listado();
    }
    else{
      this.router.navigate(['/login']);
    }
  }

  ls_listado(){
    this.lst = null;
    var sqry;
    sqry = " select" +
          " id,clave,nombre,status" + 
          " from tbldocprobatorio" +
          " where tbldocprobatorio.status <> 'C'" +
          " order by nombre";
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0){
            this.lst = data;   
          }
          else{            
            //swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  registro(itm,id){
    this.bregistro = true;
    if (id == 0){
      this.itm.id = 0;
      this.itm.clave = "";
      this.itm.nombre = "";
    }else{
      this.itm.id = itm.id;
      this.itm.clave = itm.clave;
      this.itm.nombre = itm.nombre;
    }

  }

  cancelar(){
    this.bregistro = false;
  }
  guardar(){
    if (this.itm.clave == ""){
      swal.fire('', '<h5>Proporcione la clave</h5>', 'warning');
      return;
    }
    if (this.itm.nombre == ""){
      swal.fire('', '<h5>Proporcione el nombre</h5>', 'warning');
      return;
    }

    var sqry;
    if (this.itm.id == 0){
      sqry = " insert into tbldocprobatorio (" +
             " clave,nombre,status)" +
             " values ('" +
             this.itm.clave + "','" +
             this.itm.nombre + "','" +             
             "A" + "')";
    }else{
      sqry = " update tbldocprobatorio set" +
             " clave = '" + this.itm.clave + "'," +
             " nombre = '" + this.itm.nombre + "'" +             
             " where id = " + this.itm.id;
    }
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        this.bregistro = false;
        this.ls_listado();
        if (this.itm.id == 0)
          swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        else
          swal.fire({ icon: "success", title: "Información modificada", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  elimiar(id){
    var sqry;
    sqry = " update tbldocprobatorio set status = 'C' where id = " + id;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        this.bregistro = false;
        this.ls_listado();
        swal.fire({ icon: "success", title: "Registro eliminado", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

}
